<h2 mat-dialog-title>{{ data.title }}</h2>
<input class="searchbox" placeholder="{{'GENERAL.SEARCH.PLACEHOLDER'| translate }}" [(ngModel)]="searchText">
<mat-dialog-content>
  <div (click)="selectItem(item)" class="item" *ngFor="let item of filteredItems | filter:searchText | sortBy:'skin'">
    <div [ngStyle]="{'color': item.color || 'inherit'}" class="boleta"
      [ngStyle]="{'background-color': (item.backgroundColor || 'transparent'), 'color': (item.color || 'inherit')}">
      <div class="inner-boleta">
        {{ item.skin }}
      </div>
    </div>
    <div class="description">
      <div class="key requadre">{{ item.skinSkin }}</div>{{ item.description
      }}
    </div>
  </div>

  <div *ngIf="filteredItems.length === 0" class="no-results">
    {{'GENERAL.NORESULTSFOUND'| translate }}
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="action cancel" (click)="closeDialog()">{{'GENERAL.CANCEL'| translate }}</button>
</mat-dialog-actions>